
import { colors } from './colors';

export const getThemeColors = (theme: 'light' | 'dark') => ({
  ...colors[theme],
  primary: colors.primary,
  primaryLight: colors.primaryLight,
  primaryDark: colors.primaryDark,
  accent: colors.accent,
  accentLight: colors.accentLight,
  accentDark: colors.accentDark,
  accentLighter: colors.accentLighter,
  accentDarker: colors.accentDarker,
  gradient: colors.gradient,
  error: colors.error,
  success: colors.success,
  warning: colors.warning,
});
